<template>
<div class="kb_delete">
        <div class="empty_content">
            <img src="@/assets/img/other/delete_file.png" alt=""/>
            <div class="empty_text">{{$t("知识库已删除，无法查看")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'kb_delete',
    components: {},
    mounted() {
        document.getElementById('loading')?.remove();
    },
    data() {
        return {};
    },
    computed: {},
    methods: {}
};
</script>

<style lang="scss" scoped>
.kb_delete {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 131px;
        }

        .empty_text {
            margin-top: 16px;
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #a2a4b0;
            text-align: center;
        }
    }
}
</style>
